import { InfoOutlined } from "@mui/icons-material";
import {
  Box,
  Chip,
  CircularProgress,
  Container,
  Grid,
  Grow,
  Paper,
  Typography,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import ParameterList from "../../../components/Parameter/ParameterList";
import StyledHeader from "../../../components/StyledHeader/StyledHeader";
import { annotationParameters } from "../../../constants/parameters";
import { jobInfo } from "../../../stores/request";
import Annotation from "../tabs/Annotation";
import Pssp from "../pssp/result";
const colors = {
  success: "lightSuccess",
  failed: "lightError",
  正在运行: "info",
  等待运行: "info",
};

export default function ResultDetails({ jobId }) {
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [info, setInfo] = useState(null);
  const [model, setModel] = useState(null);
  const [modelSelect, setModelSelect] = useState(null);

  useEffect(() => {
    if (jobId.length <= 8) {
      setError("Invalid jobId");
      setFetching(false);
      return;
    }
    setFetching(true);
    jobInfo(jobId.slice(8)).then(({ data, success, message }) => {
      console.log(data);
      if (success) {
        setData(data);
        setError(null);
      } else {
        setData(null);
        setError(message);
      }
      setFetching(false);
    });
  }, [jobId]);

  const [paramAnnotation, setParamAnnotation] = useState(null);
  const [graphParam, setGraphParam] = useState(null);
  const modelList = {
    1: "PepBCL",
    2: "PepBCL",
    3: "PepBCL",
    4: "PHAT-3 states",
    5: "PHAT-3 states",
    6: "PepFormer",
    7: "MEDICO",
    8: "ACPred-FL",
    9: "PEPred-Suite",
  };
  useEffect(() => {
    if (data) {
      setInfo({
        ...data.param,
        model: modelList[data.param.model],
        completeTime: data.completeTime,
        createTime: data.createTime,
        requestTime: data.requestTime,
      });
      setModel(data.param.model);

      console.log(data);

      setParamAnnotation({
        ...data.result,
      });
      if (
        data.result?.table_data?.binding_index &&
        data?.result?.table_data?.chain &&
        data?.result?.table_data?.pdbid
      ) {
        console.log(
          "asdasdasda",
          "asdasdasdasd",
          data.result?.table_data?.binding_index,
          data?.result?.table_data?.chain,
          data?.result?.table_data?.pdbid
        );
        setGraphParam({
          index: data.result.table_data.binding_index,
          chain: data.result.table_data.chain,
          pdbid: data.result.table_data.pdbid,
        });
      }
    }
  }, [data]);

  useEffect(() => {
    console.log(info);
  }, [info]);
  return (
    <Container maxWidth={false} sx={{ width: "80%" }}>
      <Box>
        {data && (
          <Box>
            <Paper
              elevation={3}
              sx={{ minWidth: 300, mt: 2, mb: 2, overflow: "hidden" }}
            >
              <StyledHeader icon={<InfoOutlined />}>
                Result Details
              </StyledHeader>
              <Grid container spacing={2} p={2}>
                <Grid item xs={12} sm={4} md={3} lg={2}>
                  <Typography variant="body1" component="div" color="GrayText">
                    Job ID: {jobId}
                  </Typography>
                  <Typography variant="body1" component="div" color="GrayText">
                    Status:{" "}
                    <Chip
                      color={colors[data.status]}
                      label={data.status}
                      sx={{ fontSize: 16 }}
                    />
                  </Typography>
                </Grid>
                {/* {info && "awdasda"} */}
                {info && (
                  <ParameterList params={annotationParameters} data={info} />
                )}
              </Grid>
            </Paper>
            {data?.status === "success" && (
              <Fragment>
                {(model === "3" ||
                  model === "2" ||
                  model === "1" ||
                  model === "7" ||
                  model === "8" ||
                  model === "9" ||
                  model === "6") && (
                  <Fragment>
                    <Annotation
                      type={model}
                      tableData={paramAnnotation}
                      GraphParam={graphParam}
                      jobid={jobId}
                    />
                  </Fragment>
                )}
                {(model === "5" || model === "4") && (
                  <Fragment>
                    <Pssp results={data.result} />
                  </Fragment>
                )}
              </Fragment>
            )}
          </Box>
        )}

        {error && (
          <Box mt={2}>
            <Paper elevation={3} sx={{ padding: 2 }}>
              <Typography variant="h4" color="error">
                Error
              </Typography>
              <Typography variant="body1" color="error">
                {error}
              </Typography>
            </Paper>
          </Box>
        )}
        <Box
          sx={{
            position: "fixed",
            top: "50%",
            left: "calc(50% - 100px)",
            width: 210,
          }}
        >
          <Grow in={fetching}>
            <Paper
              elevation={5}
              sx={{
                padding: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "12px",
              }}
            >
              <CircularProgress size={32} color="primary" sx={{ mr: 1 }} />
              <Typography variant="h6">Loading result...</Typography>
            </Paper>
          </Grow>
        </Box>
      </Box>
    </Container>
  );
}
